import axios, { AxiosError, AxiosResponse } from "axios";
import { getNavigator } from "../redux/NavigationStore";

const customAxios = axios.create();

customAxios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const status = error?.response?.status;
    const errorData = error?.response?.data;

    if ([500, 502, 503, 504].includes(status || 0)) {
      const status = error?.response?.status;

      const errorRedirects: Record<number, string> = {
        502: "/502",
        503: "/503",
        504: "/504",
      };

      const redirectPath = status && errorRedirects[status] ? errorRedirects[status] : "/500";

      const navigateFn = getNavigator();

      if (navigateFn) {
        navigateFn(redirectPath);
      } else {
        window.location.href = redirectPath;
      }
    }

    return Promise.reject(error);
  }
);

export default customAxios;
